import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    SAVE_MODULE,
    saveModuleFail,
    saveModuleSuccess
} from '../action/saveModuleAction'

// api 
import saveModuleApi from '../api/saveModuleApi'

export function* saveModuleSaga(action) {
    try {
        const response = yield call(() => saveModuleApi(action.params))
        if (response.data.status === 1) {
            yield put(saveModuleSuccess(response, action))
        } else {
            yield put(saveModuleFail(response, action))
        }
    }
    catch (e) {
        yield put(saveModuleFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(SAVE_MODULE, saveModuleSaga)
}